import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvidenceReportComponent } from './evidence-report.component';
import { EvidenceReportModuleRouter } from './evidence.router';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    EvidenceReportComponent
  ],
  imports: [
    CommonModule,
    EvidenceReportModuleRouter,
    SharedModule
  ]
})
export class EvidenceReportModule { }
